import { xml } from "@xmpp/client"
import { Element } from "@xmpp/xml"
import { Message } from "../reducers/messagesSlice"

const convert = (message: Message): Element => {
  // This is hacky, since assumes that it's groupchat with stanza-id, not gonna work for `chat`
  const subelements = [
    xml("stanza-id", {
      xmlns: "urn:xmpp:sid:0",
      by: message.from,
      id: message.id,
    }),
  ]
  if (message.url) {
    subelements.push(
      xml(
        "reference",
        { xmlns: "urn:xmpp:reference:0", type: "data" },
        xml(
          "media-sharing",
          { xmlns: "urn:xmpp:sims:1" },
          xml(
            "sources",
            {},
            xml("reference", {
              xmlns: "urn:xmpp:reference:0",
              type: "data",
              uri: message.url,
            }),
          ),
        ),
      ),
    )
  }

  if (message.body) {
    subelements.push(xml("body", {}, message.body))
  }

  return xml(
    "message",
    {
      type: message.type,
      from: message.from,
    },
    ...subelements,
  )
}

export { convert }
